import React from "react";

import styled from "styled-components";
import Button from "../../../components/Button";

export const AboutUI = styled.section`
  display: flex;
  padding: 70px 30px 70px 60px;
  width: 100%;
  justify-content: center;
  flex-direction: column;
  background-color: var(--white);
  color: var(--black);
  gap: 50px;

  @media (max-width: 992px) {
    flex-direction: column;
    gap: 50px;
    padding: 70px 10px;
  }
`;

export const Title = styled.h2`
  font-size: 2.5rem;
  font-weight: 600;
  font-family: var(--raleway);
  color: var(--black);
  text-align: center;
  span {
    color: var(--red);
  }
  @media (max-width: 400px) {
    font-size: 2.2rem;
  }
`;

export const Subtitle = styled.h3`
  font-size: 1.8rem;
  font-family: var(--raleway);
  color: var(--black);
`;

export const AboutInfoContainer = styled.div`
  display: flex;
  justify-content: center;
  align-items: center;
  justify-content: center;
  width: 100%;
  max-width: 1400px;
  margin: 0 auto;
  gap: 100px;

  @media (max-width: 1350px) {
    gap: 80px;
  }
  @media (max-width: 992px) {
    flex-direction: column;
    gap: 50px;
  }
`;

export const AboutInfo = styled.div`
  width: 50%;
  gap: 25px;
  display: flex;
  flex-direction: column;
  @media (max-width: 992px) {
    order: 2;
    justify-content: center;
    align-items: center;
    width: 100%;
  }
`;

export const Paragraph = styled.p`
  color: var(--black);
  font-size: 1.2rem;
  font-weight: 300;
  text-align: justify;
  line-height: 1.6rem;
  font-family: var(--roboto);
  @media (max-width: 1350px) {
    font-size: 1rem;
    line-height: 1.3rem;
  }
  @media (max-width: 992px) {
    width: 80%;
    text-align: center;
  }
`;

const HomeParagraph = styled(Paragraph)`
  line-height: 2rem;
  letter-spacing: 0.1rem;
  @media (max-width: 1350px) {
    font-size: 1.2rem;
    line-height: 1.6rem;
  }
`;

export const Img = styled.img`
  height: 350px;
  @media (max-width: 1350px) {
    height: 300px;
  }
  @media (max-width: 1090px) {
    height: 275px;
  }
  @media (max-width: 992px) {
    order: 1;
  }
  @media (max-width: 576px) {
    height: 200px;
  }
  @media (max-width: 400px) {
    height: 150px;
  }
`;

const About = () => {
  return (
    <>
      <AboutUI>
        <Title>
          SOBRE <span>NOSOTROS</span>
        </Title>
        <AboutInfoContainer data-aos="fade-right">
          <AboutInfo>
            <Subtitle>¿Quiénes somos?</Subtitle>
            <HomeParagraph>
              Somos una compañía líder en alquiler de vehículos. Nuestra
              experiencia nos permite seguir apostando y ampliando nuestra flota
              continuamente, respondiendo a las necesidades de movilidad para
              todo tipo de pasajeros. Nuestro compromiso es brindar calidad,
              comodidad, confort y seguridad a todos nuestros clientes.
            </HomeParagraph>
            <Button inverted text="Ver más" path="/sobre-nosotros" />
          </AboutInfo>
          <Img src="/images/home/about.png"></Img>
        </AboutInfoContainer>
      </AboutUI>
    </>
  );
};

export default About;
